import React, { FC } from 'react';
import { PopupProvider as _PopupProvider } from '@sunbit-dev/purchase-common/src/components/popupProvider/PopupProvider';
import { activePopupBackdropCss } from './styles';

export const PopupProvider: FC = ({ children }) => (
  <_PopupProvider activePopupBackdropCss={activePopupBackdropCss}>{children}</_PopupProvider>
);
